/* DropLit cart visuals + exact line-item property parsing */
(function(){
  function esc(v){return String(v==null?'':v).replace(/[&<>"']/g,function(m){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]})}
  function clean(v){return String(v==null?'':v).replace(/^\s+|\s+$/g,'')}
  function normalizeName(v){return clean(v).replace(/:\s*$/,'').toLowerCase()}

  function hiddenProp(row,name){
    var target=normalizeName(name);
    var items=row.querySelectorAll('[data-dl-property]');
    for(var i=0;i<items.length;i++){
      if(normalizeName(items[i].getAttribute('data-dl-property-name')||'')!==target)continue;
      return clean(items[i].getAttribute('data-dl-property-value')||'');
    }
    return '';
  }

  function propertyEntry(row,name){
    var target=normalizeName(name);
    var items=row.querySelectorAll('.cart-items__properties .cart-items__property');
    for(var i=0;i<items.length;i++){
      var dt=items[i].querySelector('dt');
      if(!dt||normalizeName(dt.textContent||'')!==target)continue;
      return {root:items[i],dt:dt,dd:items[i].querySelector('dd')};
    }
    return null;
  }

  function prop(row,name){
    var hidden=hiddenProp(row,name);
    if(hidden)return hidden;
    var entry=propertyEntry(row,name);
    return entry&&entry.dd?clean(entry.dd.textContent||''):'';
  }

  function artworkProp(row,name){
    var hidden=hiddenProp(row,name);
    if(hidden)return hidden;
    var entry=propertyEntry(row,name);
    if(!entry||!entry.dd)return '';
    var link=entry.dd.querySelector('a[href]');
    if(link){
      var href=link.getAttribute('href')||link.href||'';
      if(href)return href;
    }
    var img=entry.dd.querySelector('img[src]');
    if(img){
      var src=img.getAttribute('src')||img.src||'';
      if(src)return src;
    }
    var text=clean(entry.dd.textContent||'');
    var m=text.match(/(?:https?:\/\/|data:image\/)[^\s"'<>]+/i);
    return m?m[0]:text;
  }

  function hatImage(style){
    style=(style||'').toLowerCase();
    if(style.indexOf('black')>-1)return 'https://cdn.shopify.com/s/files/1/0809/5963/5641/files/droplit-hat-black.webp?v=1789229114';
    if(style.indexOf('canvas')>-1)return 'https://cdn.shopify.com/s/files/1/0809/5963/5641/files/droplit-hat-canvas.webp?v=1789229124';
    return 'https://cdn.shopify.com/s/files/1/0809/5963/5641/files/droplit-hat-white.webp?v=1789229120';
  }

  function makeVisual(img,label,sub){
    return '<div class="dl-cart-visual"><span class="dl-cart-visual__frame">'+(img?'<img src="'+esc(img)+'" alt="'+esc(label)+'">':'')+'</span><span class="dl-cart-visual__label">'+esc(label)+'</span><span class="dl-cart-visual__sub">'+esc(sub||'')+'</span></div>';
  }

  function enhanceRow(row){
    var propsNode=row.querySelector('.cart-items__properties');
    var propsText=propsNode?propsNode.textContent||'':'';
    var extra=Number(hiddenProp(row,'_DropLit Extra'));
    if(!extra&&!/Drop 1 Artwork|Hat Style/i.test(propsText)&&!hiddenProp(row,'_Drop 1 Artwork'))return;
    if(row.dataset.dlCartEnhanced==='1')return;
    var details=row.querySelector('.cart-items__details')||row.querySelector('td,div');
    if(!details)return;

    var style=prop(row,'Hat Style')||'DropLit Hat';
    var html='<div class="dl-cart-bundle-title">'+(extra?'Extra Custom Drop':'Your DropLit Bundle')+'</div><div class="dl-cart-visuals">';
    if(!extra)html+=makeVisual(hatImage(style),'Hat',style);
    for(var i=1;i<=4;i++){
      var art=artworkProp(row,'_Drop '+i+' Artwork')||artworkProp(row,'Drop '+i+' Artwork');
      if(!art)continue;
      var title=prop(row,'_Drop '+i+' Name')||'Drop '+i;
      html+=makeVisual(art,title,i<=2?'Drop '+i+' · Included':'Drop '+i+' · +$4.95');
    }
    html+='</div>';

    row.dataset.dlCartEnhanced='1';
    row.classList.add('dl-cart-bundle-row');
    details.insertAdjacentHTML('afterbegin',html);
  }

  function fixEmptyCartLink(){
    var btn=document.querySelector('.template-cart .cart-items__empty-button');
    if(!btn)return;
    btn.setAttribute('href','/');
    if(btn.dataset.dlHomeFix)return;
    btn.dataset.dlHomeFix='1';
    btn.addEventListener('click',function(e){e.preventDefault();window.location.assign('/')});
  }

  function boot(){
    document.querySelectorAll('.template-cart .cart-items__table-row').forEach(enhanceRow);
    fixEmptyCartLink();
  }

  function startObserver(){
    if(window.__dlCartVisualObserver)return;
    window.__dlCartVisualObserver=1;
    var target=document.querySelector('.template-cart #MainContent')||document.body;
    if(!target)return;
    new MutationObserver(function(){boot()}).observe(target,{childList:true,subtree:true});
  }

  function init(){boot();startObserver()}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',boot);
})();
